import { toast } from '@qodo/design-system';
import { useNavigateWithQueryParams } from 'hooks/useNavigateWithQueryParams';
import { OIDC_PROVIDER } from 'network/httpClients/OIDCAuthenticationClient/consts';
import { ROUTES, QUERY_PARAMS } from 'routes/consts';
import { mixpanelService } from 'services/mixpanel';
import {
  MIXPANEL_EVENT_NAMES,
  MIXPANEL_OPERATIONS,
} from 'services/mixpanel/consts';
import { buildMixpanelErrorData } from 'services/mixpanel/utils';
import { handleOIDCError, isOIDCError } from 'utils/authentication';
import { spawn } from 'utils/translations';
import { useEmailSender } from '../useEmailSender';
import { EmailInputForm } from './EmailInputForm';

export const Email = () => {
  const { navigateWithQueryParams } = useNavigateWithQueryParams();
  const { sendEmail } = useEmailSender();
  const spawnToast = spawn('toasts.fallback');

  const onSubmit = async (email: string) => {
    try {
      await sendEmail(email);

      navigateWithQueryParams({
        pathname: ROUTES.CHECK_YOUR_EMAIL,
        search: `${QUERY_PARAMS.EMAIL}=${encodeURIComponent(email)}`,
      });
    } catch (error: any) {
      mixpanelService.track(MIXPANEL_EVENT_NAMES.ERROR, {
        operation: MIXPANEL_OPERATIONS.LOGIN_INTERRUPTED,
        error_data: buildMixpanelErrorData(error, OIDC_PROVIDER.EMAIL),
      });

      if (isOIDCError(error)) {
        handleOIDCError(error);

        return;
      }

      if (error?.response || error?.message) {
        toast.error(
          error.response?.data?.detail || error.message || spawnToast('error'),
        );
      }
    }
  };

  return <EmailInputForm type="private" onSubmit={onSubmit} />;
};

export default Email;
